var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var LocationBold = function (prop) {
    return (_jsx("p", __assign({ className: "location text-[12px] font-bold leading-[1.67]" }, { children: prop.data }), void 0));
};
export default LocationBold;
